// utils/getPolizzaRisoltats
import { supabase } from '../supabaseClient';

type Agenzia = { nome: string } | null;
type Agente = { nome: string; cognome: string; agenzia: Agenzia } | null;

export type PolizzaRisolta = {
  id: string;
  numero_polizza: string | null;
  targa: string | null;
  nome_cliente: string | null;
  cognome_cliente: string | null;
  ragione_sociale: string | null;
  codice_fiscale: string | null;
  partita_iva: string | null;
  data_risoluzione: string | null;
  premio_restituito: number | null;
  agente: Agente;
};

export async function getPolizzaRisolta(id: string): Promise<PolizzaRisolta> {
  // 🔹 Step 1: recupera la polizza annullata + id_agente
  const { data: polizza, error } = await supabase
    .from('polizze')
    .select(`
      id,
      numero_polizza,
      targa,
      nome_cliente,
      cognome_cliente,
      ragione_sociale,
      codice_fiscale,
      partita_iva,
      data_risoluzione,
      premio_restituito,
      id_agente
    `)
    .eq('id', id)
    .eq('stato_polizza', 'ANNULLATA')
    .single();

  if (error || !polizza) throw new Error('Polizza annullata non trovata');

  let agente: Agente = null;

  // 🔹 Step 2: se presente, recupera agente + agenzia
  if (polizza.id_agente) {
    const { data: agenteData } = await supabase
      .from('utenti')
      .select(`
        nome,
        cognome,
        agenzia:agenzie ( nome )
      `)
      .eq('id', polizza.id_agente)
      .single();

    if (agenteData) {
      const agenzia = Array.isArray(agenteData.agenzia)
        ? agenteData.agenzia[0] ?? null
        : agenteData.agenzia ?? null;

      agente = {
        nome: agenteData.nome,
        cognome: agenteData.cognome,
        agenzia,
      };
    }
  }

  return {
    ...polizza,
    agente,
  };
}
